// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainPanel_main__HXiFX {
  width: 50rem;
  background-color: #fff;
  margin-top: 2rem;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: auto;
  padding-bottom: 2rem;
}
.mainPanel_main__HXiFX .mainPanel_top-banner__pRmpN {
  height: 7px;
  background-color: #1a3a51;
  width: 100%;
}
.mainPanel_main__HXiFX .mainPanel_images-container__h92k6 {
  padding: 1rem 0.75rem 1rem 2rem;
  display: flex;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(204, 204, 204, 0.4);
}
.mainPanel_main__HXiFX .mainPanel_images-container__h92k6 .mainPanel_logo__3EriW {
  margin: 1rem 0 0 1rem;
}
.mainPanel_main__HXiFX .mainPanel_images-container__h92k6 .mainPanel_clermont-hg-logo__KCD\\+h {
  height: 35px;
}
.mainPanel_main__HXiFX .mainPanel_images-container__h92k6 .mainPanel_brand-images-container__9O8zO {
  float: right;
  display: flex;
  align-items: center;
  margin-left: auto;
  box-sizing: inherit;
  margin-right: 1rem;
  border-left: 1px solid rgba(204, 204, 204, 0.4);
}
.mainPanel_main__HXiFX .mainPanel_images-container__h92k6 .mainPanel_brand-images-container__9O8zO .mainPanel_royal-horseguards-logo__mjUZN {
  width: 100px;
}
.mainPanel_main__HXiFX .mainPanel_images-container__h92k6 .mainPanel_brand-images-container__9O8zO .mainPanel_clermont-logo__wO572 {
  width: 65px;
}
.mainPanel_main__HXiFX .mainPanel_images-container__h92k6 .mainPanel_brand-images-container__9O8zO .mainPanel_hrh-london-logo__qTmYX {
  width: 41px;
}
.mainPanel_main__HXiFX .mainPanel_images-container__h92k6 .mainPanel_brand-images-container__9O8zO .mainPanel_guoman-logo__qYFOo {
  width: 44px;
}
.mainPanel_main__HXiFX .mainPanel_images-container__h92k6 .mainPanel_brand-images-container__9O8zO .mainPanel_thistle-logo__eA5U4 {
  width: 52px;
}
.mainPanel_main__HXiFX .mainPanel_images-container__h92k6 .mainPanel_brand-images-container__9O8zO .mainPanel_marblearch-logo__CpoTM {
  width: 85px;
}
.mainPanel_main__HXiFX .mainPanel_images-container__h92k6 .mainPanel_brand-images-container__9O8zO .mainPanel_cumberland-logo__QmL0m {
  width: 67px;
}
.mainPanel_main__HXiFX .mainPanel_form-body__TlDFl {
  padding: 1rem 3rem 3rem 3rem;
}
.mainPanel_main__HXiFX .mainPanel_form-body__TlDFl .mainPanel_top-break__wn1t5 {
  background-color: #1a3a51;
  border: 0;
  height: 1px;
}
.mainPanel_main__HXiFX .mainPanel_form-body__TlDFl .mainPanel_middle-break__4Dvb7 {
  background-color: #c7abd8;
  border: 0;
  height: 1px;
}
.mainPanel_main__HXiFX .mainPanel_form-body__TlDFl .mainPanel_input-group__VxFQA {
  width: 100%;
  display: flex;
}
.mainPanel_main__HXiFX .mainPanel_form-body__TlDFl .mainPanel_input-group__VxFQA .mainPanel_details-input-container-left__Bu6S5 {
  width: 50%;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  box-sizing: border-box;
}
.mainPanel_main__HXiFX .mainPanel_form-body__TlDFl .mainPanel_input-group__VxFQA .mainPanel_details-input-container-right__7S8Un {
  width: 50%;
  padding-left: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  box-sizing: border-box;
}
.mainPanel_main__HXiFX .mainPanel_form-body__TlDFl .mainPanel_input-group__VxFQA .mainPanel_details-input__KxAcQ {
  border: 1px solid #c7abd8;
  width: 100%;
  padding: 0 0.3rem 0 0.3rem;
  height: 1.8rem;
  border-radius: 2px;
  max-width: 100%;
  box-sizing: inherit;
}
.mainPanel_main__HXiFX .mainPanel_form-body__TlDFl .mainPanel_input-group__VxFQA .mainPanel_details-select__2vXOB {
  border: 1px solid #c7abd8;
  width: 100%;
  padding: 0 0.3rem 0 0.3rem;
  height: 1.8rem;
  border-radius: 2px;
  box-sizing: inherit;
}
.mainPanel_main__HXiFX .mainPanel_form-body__TlDFl input[type=checkbox] {
  accent-color: #c7abd8;
  vertical-align: middle;
  margin: 1rem 0rem;
  height: 14px;
  width: 14px;
}
.mainPanel_main__HXiFX .mainPanel_form-body__TlDFl .mainPanel_checkbox-label__gFHqt {
  padding-left: 0.6rem;
  vertical-align: middle;
}
.mainPanel_main__HXiFX .mainPanel_form-body__TlDFl .mainPanel_privacy-policy-btn__RXd2d {
  cursor: pointer;
  color: blue;
}
.mainPanel_main__HXiFX .mainPanel_form-body__TlDFl input[type=checkbox]:checked + label::after {
  border: 3px solid #fff;
}
.mainPanel_main__HXiFX .mainPanel_form-body__TlDFl input[type=button],
.mainPanel_main__HXiFX .mainPanel_form-body__TlDFl input[type=submit] {
  border: none;
  background-color: #c7abd8;
  color: white;
  padding: 0.4rem 1rem 0.4em 1rem;
  letter-spacing: 1px;
  margin: 1rem 0 1rem 0;
  font-size: 14px;
}
.mainPanel_main__HXiFX .mainPanel_form-body__TlDFl input[type=button]:hover,
.mainPanel_main__HXiFX .mainPanel_form-body__TlDFl input[type=submit]:hover {
  background-color: #c7abd8;
  cursor: pointer;
}
.mainPanel_main__HXiFX .mainPanel_form-body__TlDFl input[type=button]:disabled,
.mainPanel_main__HXiFX .mainPanel_form-body__TlDFl input[type=submit]:disabled {
  background-color: #cccccc;
  color: #666666;
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/components/mainPanel.module.scss"],"names":[],"mappings":"AAGA;EACE,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;AAFF;AAIE;EACE,WAAA;EACA,yBAdU;EAeV,WAAA;AAFJ;AAKE;EACE,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,iDAAA;AAHJ;AAKI;EACE,qBAAA;AAHN;AAMI;EACE,YAAA;AAJN;AAOI;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,+CAAA;AALN;AAOM;EACE,YAAA;AALR;AAQM;EACE,WAAA;AANR;AASM;EACE,WAAA;AAPR;AAUM;EACE,WAAA;AARR;AAWM;EACE,WAAA;AATR;AAWM;EACE,WAAA;AATR;AAWM;EACE,WAAA;AATR;AAkBE;EACE,4BAAA;AAhBJ;AAkBI;EACE,yBA7EQ;EA8ER,SAAA;EACA,WAAA;AAhBN;AAmBI;EACE,yBAlFY;EAmFZ,SAAA;EACA,WAAA;AAjBN;AAoBI;EACE,WAAA;EACA,aAAA;AAlBN;AAoBM;EACE,UAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;AAlBR;AAqBM;EACE,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;AAnBR;AAsBM;EACE,yBAAA;EACA,WAAA;EACA,0BAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AApBR;AAuBM;EACE,yBAAA;EACA,WAAA;EACA,0BAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AArBR;AAsFI;EACE,qBA7LY;EA8LZ,sBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;AApFN;AAuFI;EACE,oBAAA;EACA,sBAAA;AArFN;AAwFI;EACE,eAAA;EACA,WAAA;AAtFN;AAyFI;EACE,sBAAA;AAvFN;AA0FI;;EAEE,YAAA;EACA,yBArNY;EAsNZ,YAAA;EACA,+BAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AAxFN;AA2FI;;EAEE,yBA/NY;EAgOZ,eAAA;AAzFN;AA4FI;;EAEE,yBAAA;EACA,cAAA;EACA,eAAA;AA1FN","sourcesContent":["$banner-blue: #1a3a51;\r\n$clermont-purple: #c7abd8;\r\n\r\n.main {\r\n  width: 50rem;\r\n  background-color: #fff;\r\n  margin-top: 2rem;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  margin-bottom: auto;\r\n  padding-bottom: 2rem;\r\n\r\n  .top-banner {\r\n    height: 7px;\r\n    background-color: $banner-blue;\r\n    width: 100%;\r\n  }\r\n\r\n  .images-container {\r\n    padding: 1rem 0.75rem 1rem 2rem;\r\n    display: flex;\r\n    box-sizing: border-box;\r\n    border-bottom: 1px solid rgba(#ccc, 0.4);\r\n\r\n    .logo {\r\n      margin: 1rem 0 0 1rem;\r\n    }\r\n\r\n    .clermont-hg-logo {\r\n      height: 35px;\r\n    }\r\n\r\n    .brand-images-container {\r\n      float: right;\r\n      display: flex;\r\n      align-items: center;\r\n      margin-left: auto;\r\n      box-sizing: inherit;\r\n      margin-right: 1rem;\r\n      border-left: 1px solid rgba(#ccc, 0.4);\r\n\r\n      .royal-horseguards-logo {\r\n        width: 100px;\r\n      }\r\n\r\n      .clermont-logo {\r\n        width: 65px;\r\n      }\r\n\r\n      .hrh-london-logo {\r\n        width: 41px;\r\n      }\r\n\r\n      .guoman-logo {\r\n        width: 44px;\r\n      }\r\n\r\n      .thistle-logo {\r\n        width: 52px;\r\n      }\r\n      .marblearch-logo {\r\n        width: 85px;\r\n      }\r\n      .cumberland-logo {\r\n        width: 67px;\r\n      }\r\n\r\n      // .thistle-express-logo {\r\n      //     width: 48px;\r\n      // }\r\n    }\r\n  }\r\n\r\n  .form-body {\r\n    padding: 1rem 3rem 3rem 3rem;\r\n\r\n    .top-break {\r\n      background-color: $banner-blue;\r\n      border: 0;\r\n      height: 1px;\r\n    }\r\n\r\n    .middle-break {\r\n      background-color: $clermont-purple;\r\n      border: 0;\r\n      height: 1px;\r\n    }\r\n\r\n    .input-group {\r\n      width: 100%;\r\n      display: flex;\r\n\r\n      .details-input-container-left {\r\n        width: 50%;\r\n        padding-right: 1rem;\r\n        padding-top: 0.5rem;\r\n        padding-bottom: 0.5rem;\r\n        box-sizing: border-box;\r\n      }\r\n\r\n      .details-input-container-right {\r\n        width: 50%;\r\n        padding-left: 1rem;\r\n        padding-top: 0.5rem;\r\n        padding-bottom: 0.5rem;\r\n        box-sizing: border-box;\r\n      }\r\n\r\n      .details-input {\r\n        border: 1px solid $clermont-purple;\r\n        width: 100%;\r\n        padding: 0 0.3rem 0 0.3rem;\r\n        height: 1.8rem;\r\n        border-radius: 2px;\r\n        max-width: 100%;\r\n        box-sizing: inherit;\r\n      }\r\n\r\n      .details-select {\r\n        border: 1px solid $clermont-purple;\r\n        width: 100%;\r\n        padding: 0 0.3rem 0 0.3rem;\r\n        height: 1.8rem;\r\n        border-radius: 2px;\r\n        box-sizing: inherit;\r\n      }\r\n    }\r\n\r\n    // label,\r\n    // input[type=\"radio\"],\r\n    // input[type=\"checkbox\"] {\r\n    //     line-height: 2.1ex;\r\n    // }\r\n\r\n    // input[type=\"radio\"],\r\n    // input[type=\"checkbox\"] {\r\n    //     position: absolute;\r\n    //     left: -999em;\r\n    // }\r\n\r\n    // input[type=\"radio\"] + label,\r\n    // input[type=\"checkbox\"] + label {\r\n    //     position: relative;\r\n    //     overflow: hidden;\r\n    //     cursor: pointer;\r\n    // }\r\n\r\n    // input[type=\"radio\"] + label::before,\r\n    // input[type=\"checkbox\"] + label::before {\r\n    //     content: \"\";\r\n    //     display: inline-block;\r\n    //     vertical-align: -25%;\r\n    //     height: 1rem;\r\n    //     width: 1rem;\r\n    //     background-color: transparent;\r\n    //     border: 1px solid rgb(166, 166, 166);\r\n    //     margin-right: 0.5em;\r\n    // }\r\n\r\n    // input[type=\"radio\"]:checked + label::before {\r\n    //     background: radial-gradient(\r\n    //         circle at center,\r\n    //         #1062a4 0.6ex,\r\n    //         white 0.7ex\r\n    //     );\r\n    // }\r\n\r\n    // input[type=\"radio\"] + label::before {\r\n    //     border-radius: 50%;\r\n    // }\r\n\r\n    // input[type=\"checkbox\"]:checked + label::after {\r\n    //     content: \"\";\r\n    //     position: absolute;\r\n    //     width: 1.2ex;\r\n    //     height: 0.4ex;\r\n    //     background: rgba(0, 0, 0, 0);\r\n    //     top: 0.9ex;\r\n    //     left: 0.4ex;\r\n    //     border: 3px solid #fff;\r\n    //     border-top: none;\r\n    //     border-right: none;\r\n    //     -webkit-transform: rotate(-45deg);\r\n    //     -moz-transform: rotate(-45deg);\r\n    //     -o-transform: rotate(-45deg);\r\n    //     -ms-transform: rotate(-45deg);\r\n    //     transform: rotate(-45deg);\r\n    // }\r\n\r\n    input[type=\"checkbox\"] {\r\n      accent-color: $clermont-purple;\r\n      vertical-align: middle;\r\n      margin: 1rem 0rem;\r\n      height: 14px;\r\n      width: 14px;\r\n    }\r\n\r\n    .checkbox-label {\r\n      padding-left: 0.6rem;\r\n      vertical-align: middle;\r\n    }\r\n\r\n    .privacy-policy-btn {\r\n      cursor: pointer;\r\n      color: blue;\r\n    }\r\n\r\n    input[type=\"checkbox\"]:checked + label::after {\r\n      border: 3px solid #fff;\r\n    }\r\n\r\n    input[type=\"button\"],\r\n    input[type=\"submit\"] {\r\n      border: none;\r\n      background-color: $clermont-purple;\r\n      color: white;\r\n      padding: 0.4rem 1rem 0.4em 1rem;\r\n      letter-spacing: 1px;\r\n      margin: 1rem 0 1rem 0;\r\n      font-size: 14px;\r\n    }\r\n\r\n    input[type=\"button\"]:hover,\r\n    input[type=\"submit\"]:hover {\r\n      background-color: $clermont-purple;\r\n      cursor: pointer;\r\n    }\r\n\r\n    input[type=\"button\"]:disabled,\r\n    input[type=\"submit\"]:disabled {\r\n      background-color: #cccccc;\r\n      color: #666666;\r\n      cursor: default;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `mainPanel_main__HXiFX`,
	"top-banner": `mainPanel_top-banner__pRmpN`,
	"images-container": `mainPanel_images-container__h92k6`,
	"logo": `mainPanel_logo__3EriW`,
	"clermont-hg-logo": `mainPanel_clermont-hg-logo__KCD+h`,
	"brand-images-container": `mainPanel_brand-images-container__9O8zO`,
	"royal-horseguards-logo": `mainPanel_royal-horseguards-logo__mjUZN`,
	"clermont-logo": `mainPanel_clermont-logo__wO572`,
	"hrh-london-logo": `mainPanel_hrh-london-logo__qTmYX`,
	"guoman-logo": `mainPanel_guoman-logo__qYFOo`,
	"thistle-logo": `mainPanel_thistle-logo__eA5U4`,
	"marblearch-logo": `mainPanel_marblearch-logo__CpoTM`,
	"cumberland-logo": `mainPanel_cumberland-logo__QmL0m`,
	"form-body": `mainPanel_form-body__TlDFl`,
	"top-break": `mainPanel_top-break__wn1t5`,
	"middle-break": `mainPanel_middle-break__4Dvb7`,
	"input-group": `mainPanel_input-group__VxFQA`,
	"details-input-container-left": `mainPanel_details-input-container-left__Bu6S5`,
	"details-input-container-right": `mainPanel_details-input-container-right__7S8Un`,
	"details-input": `mainPanel_details-input__KxAcQ`,
	"details-select": `mainPanel_details-select__2vXOB`,
	"checkbox-label": `mainPanel_checkbox-label__gFHqt`,
	"privacy-policy-btn": `mainPanel_privacy-policy-btn__RXd2d`
};
export default ___CSS_LOADER_EXPORT___;
